// 1Rotary Trading Corporation — Comprehensive sample/seed data
// All currency in Philippine Peso (₱)

// Deterministic pseudo-random for stable data across renders
let _seed = 20260115;
function rnd() {
  _seed = (_seed * 1664525 + 1013904223) % 4294967296;
  return _seed / 4294967296;
}
function r(min, max) { return min + rnd() * (max - min); }
function ri(min, max) { return Math.floor(r(min, max + 1)); }
function pick(arr) { return arr[Math.floor(rnd() * arr.length)]; }

// ----- BRANDS / REGIONS / BRANCHES -----
export const BRANDS = ["1Rotary", "ROTEK", "North ROTEK"];
export const REGIONS = ["Metro Manila", "South Luzon", "North Luzon", "Visayas", "Mindanao"];

const BRANCH_SEED = [
  // 1Rotary — Metro Manila + flagship Luzon (flagship)
  { brand: "1Rotary", region: "Metro Manila", name: "Bacoor Cavite" },
  { brand: "1Rotary", region: "Metro Manila", name: "Parañaque Sucat" },
  { brand: "1Rotary", region: "Metro Manila", name: "Parañaque BF" },
  { brand: "1Rotary", region: "Metro Manila", name: "Pasig Ortigas" },
  { brand: "1Rotary", region: "Metro Manila", name: "Pasig C-5" },
  { brand: "1Rotary", region: "Metro Manila", name: "Pasig Pioneer" },
  { brand: "1Rotary", region: "Metro Manila", name: "Caloocan" },
  { brand: "1Rotary", region: "Metro Manila", name: "Las Piñas Alabang" },
  { brand: "1Rotary", region: "Metro Manila", name: "Las Piñas Zapote" },
  { brand: "1Rotary", region: "Metro Manila", name: "Makati Chino Roces" },
  { brand: "1Rotary", region: "South Luzon", name: "General Trias" },
  { brand: "1Rotary", region: "South Luzon", name: "GMA Cavite" },
  { brand: "1Rotary", region: "Metro Manila", name: "Mandaluyong Shaw" },
  { brand: "1Rotary", region: "Visayas", name: "Mandaue Cebu" },
  { brand: "1Rotary", region: "South Luzon", name: "Noveleta Cavite" },
  { brand: "1Rotary", region: "Metro Manila", name: "Quezon City Commonwealth" },
  { brand: "1Rotary", region: "Metro Manila", name: "Sampaloc Manila" },
  { brand: "1Rotary", region: "South Luzon", name: "Tanza Cavite" },
  { brand: "1Rotary", region: "Metro Manila", name: "Valenzuela" },
  { brand: "1Rotary", region: "Metro Manila", name: "Quezon City Cubao" },
  { brand: "1Rotary", region: "Metro Manila", name: "Marikina" },
  { brand: "1Rotary", region: "Metro Manila", name: "Pasay Roxas" },
  { brand: "1Rotary", region: "Metro Manila", name: "Manila Quiapo" },
  { brand: "1Rotary", region: "Metro Manila", name: "Taguig FTI" },
  { brand: "1Rotary", region: "Metro Manila", name: "Muntinlupa" },
  // ROTEK — South Luzon / Visayas expansion
  { brand: "ROTEK", region: "South Luzon", name: "Antipolo" },
  { brand: "ROTEK", region: "South Luzon", name: "Batangas City" },
  { brand: "ROTEK", region: "South Luzon", name: "Binangonan" },
  { brand: "ROTEK", region: "South Luzon", name: "Cainta Junction" },
  { brand: "ROTEK", region: "South Luzon", name: "Cainta Ortigas Ext" },
  { brand: "ROTEK", region: "South Luzon", name: "Calapan Mindoro" },
  { brand: "ROTEK", region: "South Luzon", name: "Legazpi Albay" },
  { brand: "ROTEK", region: "South Luzon", name: "Lipa Batangas" },
  { brand: "ROTEK", region: "South Luzon", name: "Lucena Diversion" },
  { brand: "ROTEK", region: "South Luzon", name: "Lucena Quezon Ave" },
  { brand: "ROTEK", region: "South Luzon", name: "Naga City" },
  { brand: "ROTEK", region: "South Luzon", name: "Puerto Princesa" },
  { brand: "ROTEK", region: "South Luzon", name: "San Pablo Laguna" },
  { brand: "ROTEK", region: "South Luzon", name: "Sta. Cruz Laguna" },
  { brand: "ROTEK", region: "Visayas", name: "Tacloban Leyte" },
  { brand: "ROTEK", region: "South Luzon", name: "Calamba" },
  { brand: "ROTEK", region: "South Luzon", name: "Sta. Rosa" },
  { brand: "ROTEK", region: "South Luzon", name: "Tagaytay" },
  { brand: "ROTEK", region: "South Luzon", name: "Daet Camarines" },
  { brand: "ROTEK", region: "South Luzon", name: "Sorsogon" },
  { brand: "ROTEK", region: "Visayas", name: "Iloilo City" },
  { brand: "ROTEK", region: "Visayas", name: "Bacolod" },
  { brand: "ROTEK", region: "Visayas", name: "Dumaguete" },
  { brand: "ROTEK", region: "Visayas", name: "Tagbilaran Bohol" },
  { brand: "ROTEK", region: "Visayas", name: "Ormoc" },
  // North ROTEK
  { brand: "North ROTEK", region: "North Luzon", name: "Baguio" },
  { brand: "North ROTEK", region: "North Luzon", name: "Baliuag Bulacan" },
  { brand: "North ROTEK", region: "North Luzon", name: "Bataan Balanga" },
  { brand: "North ROTEK", region: "North Luzon", name: "Cabanatuan East" },
  { brand: "North ROTEK", region: "North Luzon", name: "Cabanatuan Maharlika" },
  { brand: "North ROTEK", region: "North Luzon", name: "Cauayan Isabela" },
  { brand: "North ROTEK", region: "North Luzon", name: "Dagupan" },
  { brand: "North ROTEK", region: "North Luzon", name: "Laoag Ilocos" },
  { brand: "North ROTEK", region: "North Luzon", name: "La Union San Fernando" },
  { brand: "North ROTEK", region: "North Luzon", name: "La Union Agoo" },
  { brand: "North ROTEK", region: "North Luzon", name: "Mexico Pampanga" },
  { brand: "North ROTEK", region: "North Luzon", name: "Olongapo" },
  { brand: "North ROTEK", region: "North Luzon", name: "QC Mindanao Ave" },
  { brand: "North ROTEK", region: "North Luzon", name: "San Fernando Pampanga" },
  { brand: "North ROTEK", region: "North Luzon", name: "Santiago Isabela" },
  { brand: "North ROTEK", region: "North Luzon", name: "Subic" },
  { brand: "North ROTEK", region: "North Luzon", name: "Tarlac" },
  { brand: "North ROTEK", region: "North Luzon", name: "Tuguegarao" },
  { brand: "North ROTEK", region: "North Luzon", name: "Urdaneta" },
  { brand: "North ROTEK", region: "North Luzon", name: "Vigan" },
  { brand: "North ROTEK", region: "North Luzon", name: "Malolos Bulacan" },
  { brand: "North ROTEK", region: "North Luzon", name: "Meycauayan" },
  { brand: "North ROTEK", region: "North Luzon", name: "Iba Zambales" },
  { brand: "North ROTEK", region: "North Luzon", name: "Aparri" },
  { brand: "North ROTEK", region: "North Luzon", name: "Solano Nueva Vizcaya" },
  // Visayas extras
  { brand: "1Rotary", region: "Visayas", name: "Cebu City" },
  { brand: "1Rotary", region: "Visayas", name: "Lapu-Lapu" },
  { brand: "ROTEK", region: "Visayas", name: "Cebu South" },
  // Mindanao expansion
  { brand: "1Rotary", region: "Mindanao", name: "Davao City" },
  { brand: "1Rotary", region: "Mindanao", name: "Cagayan de Oro" },
  { brand: "1Rotary", region: "Mindanao", name: "General Santos" },
  { brand: "1Rotary", region: "Mindanao", name: "Zamboanga" },
  { brand: "1Rotary", region: "Mindanao", name: "Butuan" },
  { brand: "1Rotary", region: "Mindanao", name: "Iligan" },
  { brand: "1Rotary", region: "Mindanao", name: "Cotabato" },
  { brand: "1Rotary", region: "Mindanao", name: "Tagum" },
];

// Approximate lat/long for branch network map (Philippines bounds ~4-20N, 116-127E)
const COORDS = {
  "Metro Manila": [
    [14.45, 120.95], [14.51, 121.01], [14.48, 121.04], [14.58, 121.06], [14.57, 121.10],
    [14.59, 121.05], [14.65, 121.00], [14.43, 121.01], [14.46, 120.98], [14.56, 121.02],
    [14.45, 120.92], [14.42, 120.88], [14.58, 121.04], [14.65, 121.05], [14.50, 120.92],
    [14.69, 121.05], [14.60, 120.99], [14.40, 120.85], [14.69, 120.98], [14.62, 121.05],
    [14.65, 121.10], [14.54, 121.00], [14.60, 120.98], [14.51, 121.05], [14.38, 121.04],
  ],
  "South Luzon": [
    [14.62, 121.18], [13.76, 121.06], [14.46, 121.20], [14.57, 121.12], [14.58, 121.13],
    [13.40, 121.18], [13.15, 123.74], [13.94, 121.16], [13.93, 121.61], [13.93, 121.61],
    [13.63, 123.18], [9.74, 118.74], [14.07, 121.32], [14.28, 121.42], [11.24, 125.00],
    [14.21, 121.16], [14.31, 121.11], [14.10, 121.00], [14.11, 122.95], [12.97, 124.00],
    [10.71, 122.56], [10.67, 122.95], [9.31, 123.30], [9.65, 123.86], [11.00, 124.61],
    [14.42, 120.88], [14.42, 121.00], [14.10, 121.32], [14.05, 121.31], [13.78, 121.07],
  ],
  "North Luzon": [
    [16.41, 120.59], [14.95, 120.91], [14.68, 120.54], [15.49, 120.97], [15.50, 121.00],
    [16.93, 121.77], [16.04, 120.34], [18.20, 120.59], [16.62, 120.32], [16.32, 120.37],
    [15.06, 120.71], [14.83, 120.28], [14.74, 121.06], [15.04, 120.69], [16.69, 121.55],
    [14.80, 120.28], [15.49, 120.59], [17.61, 121.73], [15.98, 120.57], [17.57, 120.39],
    [14.85, 120.81], [14.74, 120.95], [15.33, 119.97], [18.36, 121.64], [16.52, 121.18],
  ],
  "Visayas": [
    [10.32, 123.94], [10.31, 123.94], [10.31, 123.95], [10.71, 122.57], [10.67, 122.95],
    [9.31, 123.30], [9.65, 123.86], [11.00, 124.61], [11.24, 125.00],
  ],
  "Mindanao": [
    [7.07, 125.61], [8.48, 124.65], [6.11, 125.17], [6.92, 122.08], [8.95, 125.54],
    [8.23, 124.24], [7.22, 124.25], [7.45, 125.81],
  ],
};

let coordIdx = { "Metro Manila": 0, "South Luzon": 0, "North Luzon": 0, Visayas: 0, Mindanao: 0 };
function nextCoord(region) {
  const arr = COORDS[region] || COORDS["Metro Manila"];
  const c = arr[coordIdx[region] % arr.length];
  coordIdx[region]++;
  return c;
}

export const BRANCHES = BRANCH_SEED.map((b, i) => {
  const target = ri(2_400_000, 8_500_000);
  const ach = r(0.78, 1.18);
  const actual = Math.round(target * ach);
  const skuCount = ri(420, 880);
  const stockoutRate = r(0.018, 0.092);
  const overstockRate = r(0.04, 0.16);
  const invValue = ri(3_800_000, 11_500_000);
  const headcount = ri(6, 22);
  const accuracy = r(0.93, 0.995);
  const [lat, lng] = nextCoord(b.region);
  return {
    id: `BR-${String(i + 1).padStart(3, "0")}`,
    code: `${b.brand.slice(0, 2).toUpperCase()}-${String(i + 1).padStart(3, "0")}`,
    name: b.name,
    brand: b.brand,
    region: b.region,
    lat, lng,
    monthlyTarget: target,
    monthlyActual: actual,
    achievement: actual / target,
    skuCount,
    stockoutRate,
    overstockRate,
    inventoryValue: invValue,
    headcount,
    inventoryAccuracy: accuracy,
    daysOnHand: ri(28, 72),
    manager: pick(["R. Cruz", "M. Reyes", "J. Santos", "A. Garcia", "P. Mendoza", "L. Ramos", "K. Tan", "B. Aquino", "E. Villanueva", "G. Dela Cruz"]),
  };
});

// ----- SKU CATEGORIES & SAMPLE SKUs -----
export const CATEGORIES = [
  { id: "AUTO", name: "Automotive (Car Aircon)", color: "var(--chart-1)" },
  { id: "HVAC", name: "Residential & Commercial HVAC", color: "var(--chart-2)" },
  { id: "REFR", name: "Refrigeration", color: "var(--chart-3)" },
  { id: "CONS", name: "Consumables & Tools", color: "var(--chart-5)" },
];

const SKU_TEMPLATES = [
  // Auto
  { cat: "AUTO", n: "Sanden SD7H15 Compressor", abc: "A" },
  { cat: "AUTO", n: "Capella Auto Compressor TM-16", abc: "A" },
  { cat: "AUTO", n: "OEM Toyota Vios Compressor", abc: "A" },
  { cat: "AUTO", n: "Mitsubishi Adventure Blower Motor", abc: "B" },
  { cat: "AUTO", n: "Nissan Sentra Condenser Motor", abc: "B" },
  { cat: "AUTO", n: "Honda CR-V Auxiliary Fan", abc: "C" },
  { cat: "AUTO", n: "Hyundai Accent Evaporator", abc: "B" },
  { cat: "AUTO", n: "Ford Ranger Condenser", abc: "A" },
  { cat: "AUTO", n: "Isuzu D-Max Magnetic Clutch", abc: "A" },
  { cat: "AUTO", n: "Kia Picanto Idler Pulley", abc: "C" },
  { cat: "AUTO", n: "Mazda 3 Expansion Valve", abc: "C" },
  { cat: "AUTO", n: "Suzuki APV Drier", abc: "B" },
  { cat: "AUTO", n: "Chevrolet Sail Bracket Kit", abc: "C" },
  { cat: "AUTO", n: "BMW 3-Series Discharge Hose", abc: "B" },
  // HVAC
  { cat: "HVAC", n: "Rotary Compressor 1.0HP", abc: "A" },
  { cat: "HVAC", n: "Inverter Compressor 1.5HP", abc: "A" },
  { cat: "HVAC", n: "Scroll Compressor 3.0HP", abc: "A" },
  { cat: "HVAC", n: "Running Capacitor 35µF", abc: "B" },
  { cat: "HVAC", n: "Fan Capacitor 6µF", abc: "B" },
  { cat: "HVAC", n: "Digital Thermostat", abc: "B" },
  { cat: "HVAC", n: "Universal Aircon Control PCB", abc: "B" },
  { cat: "HVAC", n: "Foam Filter Roll", abc: "C" },
  { cat: "HVAC", n: "Door Gasket Magnetic", abc: "C" },
  { cat: "HVAC", n: "Copper Tubing 1/4\" (15m)", abc: "A" },
  { cat: "HVAC", n: "Superlon Rubber Insulation 1/2\"", abc: "B" },
  { cat: "HVAC", n: "Solenoid Valve 1/4\"", abc: "C" },
  // Refrigeration
  { cat: "REFR", n: "Matsushita Refrig Compressor 1/4HP", abc: "A" },
  { cat: "REFR", n: "Capella Refrig Compressor 1/3HP", abc: "A" },
  { cat: "REFR", n: "Freezer Condenser Motor", abc: "B" },
  { cat: "REFR", n: "Refrig Door Gasket 24in", abc: "C" },
  { cat: "REFR", n: "Freon R134a 13.6kg", abc: "A" },
  { cat: "REFR", n: "Freon R410A 11.3kg", abc: "A" },
  { cat: "REFR", n: "Freon R32 9.5kg", abc: "A" },
  { cat: "REFR", n: "Freon R22 13.6kg", abc: "B" },
  { cat: "REFR", n: "Refrig Oil POE 1L", abc: "B" },
  { cat: "REFR", n: "Drier Filter 053", abc: "C" },
  // Consumables
  { cat: "CONS", n: "Charging Hose Set R134a", abc: "B" },
  { cat: "CONS", n: "Manifold Gauge Dual", abc: "B" },
  { cat: "CONS", n: "Vacuum Pump 2-stage", abc: "C" },
  { cat: "CONS", n: "Blow Torch Kit", abc: "C" },
  { cat: "CONS", n: "Clamp Meter Tester", abc: "C" },
  { cat: "CONS", n: "Copper Coupling 3/8\"", abc: "C" },
  { cat: "CONS", n: "Brazing Flux 250g", abc: "C" },
];

export const SKUS = SKU_TEMPLATES.map((s, i) => {
  const unitCost = ri(280, 28_500);
  const margin = r(0.18, 0.42);
  return {
    id: `SKU-${String(10000 + i).padStart(5, "0")}`,
    name: s.n,
    category: s.cat,
    abc: s.abc,
    unitCost,
    unitPrice: Math.round(unitCost * (1 + margin)),
    leadTimeDays: s.cat === "AUTO" || s.cat === "REFR" ? ri(45, 95) : ri(14, 42),
    supplierCountry: pick(["China", "Japan", "Korea", "Thailand", "Local PH", "Malaysia"]),
    velocityIndex: r(0.2, 1),
    monthlyUnits: ri(40, 6500),
  };
});

// ----- SUPPLIERS -----
export const SUPPLIERS = [
  { id: "SUP-001", name: "Sanden International", country: "Japan", category: "AUTO", leadTime: 75, otd: 0.92, rating: 4.6, openPOs: 8, totalValue: 24_500_000 },
  { id: "SUP-002", name: "Capella Industrial Ltd.", country: "China", category: "AUTO/REFR", leadTime: 62, otd: 0.84, rating: 4.1, openPOs: 14, totalValue: 31_200_000 },
  { id: "SUP-003", name: "Matsushita / Panasonic", country: "Japan", category: "REFR", leadTime: 80, otd: 0.95, rating: 4.8, openPOs: 6, totalValue: 18_800_000 },
  { id: "SUP-004", name: "Superlon Worldwide", country: "Malaysia", category: "HVAC", leadTime: 32, otd: 0.88, rating: 4.3, openPOs: 5, totalValue: 6_400_000 },
  { id: "SUP-005", name: "Daikin Parts Asia", country: "Thailand", category: "HVAC", leadTime: 45, otd: 0.81, rating: 4.0, openPOs: 11, totalValue: 22_900_000 },
  { id: "SUP-006", name: "Honeywell Refrigerants", country: "USA", category: "REFR", leadTime: 60, otd: 0.74, rating: 3.6, openPOs: 7, totalValue: 14_300_000 },
  { id: "SUP-007", name: "GMCC Compressors", country: "China", category: "HVAC", leadTime: 55, otd: 0.79, rating: 3.9, openPOs: 9, totalValue: 19_700_000 },
  { id: "SUP-008", name: "Highly Marelli", country: "Korea", category: "AUTO", leadTime: 70, otd: 0.90, rating: 4.5, openPOs: 4, totalValue: 11_800_000 },
  { id: "SUP-009", name: "Local Manila Distributors", country: "Local PH", category: "CONS", leadTime: 5, otd: 0.97, rating: 4.7, openPOs: 22, totalValue: 4_200_000 },
  { id: "SUP-010", name: "Embraco Brazil", country: "Brazil", category: "REFR", leadTime: 92, otd: 0.71, rating: 3.4, openPOs: 3, totalValue: 8_900_000 },
];

// ----- TIME SERIES (last 30 days) -----
const today = new Date();
function dayLabel(offset) {
  const d = new Date(today);
  d.setDate(d.getDate() - offset);
  return d.toISOString().slice(5, 10);
}

export const DAILY_REVENUE = Array.from({ length: 30 }).map((_, i) => {
  const offset = 29 - i;
  const base = 4_800_000 + i * 32_000;
  const physical = base * r(0.55, 0.72);
  const shopee = base * r(0.10, 0.20);
  const direct = base * r(0.10, 0.18);
  return {
    date: dayLabel(offset),
    physical: Math.round(physical),
    shopee: Math.round(shopee),
    direct: Math.round(direct),
    total: Math.round(physical + shopee + direct),
  };
});

export const MONTHLY_REVENUE = Array.from({ length: 12 }).map((_, i) => {
  const months = ["Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan"];
  const seasonality = [0.85, 0.92, 1.18, 1.32, 1.28, 1.10, 0.98, 0.94, 0.96, 1.02, 1.08, 0.99];
  const base = 142_000_000;
  return {
    month: months[i],
    revenue: Math.round(base * seasonality[i] * r(0.96, 1.06)),
    cogs: Math.round(base * seasonality[i] * r(0.62, 0.71)),
    target: Math.round(base * seasonality[i] * r(0.94, 1.02)),
  };
});

// ----- ALERTS -----
const ALERT_TYPES = [
  { kind: "stockout", severity: "critical", text: "Stockout: Sanden SD7H15 Compressor at 8 branches" },
  { kind: "stockout", severity: "critical", text: "Stockout: Freon R32 9.5kg at Cebu, Mandaue, Lapu-Lapu" },
  { kind: "overstock", severity: "warning", text: "Overstock: Foam Filter Roll – 142 days on hand (Davao)" },
  { kind: "supplier", severity: "warning", text: "Capella shipment delayed 14 days — port congestion (Manila)" },
  { kind: "anomaly", severity: "info", text: "+38% Freon R410A demand spike in Pampanga (heat advisory)" },
  { kind: "anomaly", severity: "info", text: "Shopee conversion +22% wk/wk on inverter compressors" },
  { kind: "forecast", severity: "info", text: "AI forecast: +24% demand for blower motors (Mar–May)" },
  { kind: "stockout", severity: "critical", text: "Stockout: Inverter Compressor 1.5HP at Tarlac, Olongapo" },
  { kind: "overstock", severity: "warning", text: "Overstock: Door Gasket Magnetic at 14 branches (>90 DOH)" },
  { kind: "supplier", severity: "warning", text: "Honeywell OTD trending below 75% — 6-month low" },
];

export const ALERTS = ALERT_TYPES.map((a, i) => ({
  id: `ALERT-${i + 1}`,
  ...a,
  branch: pick(BRANCHES).name,
  timeAgo: `${ri(2, 240)}m ago`,
}));

// ----- KPI snapshot -----
export const KPI_SNAPSHOT = {
  totalRevenueMTD: BRANCHES.reduce((s, b) => s + b.monthlyActual, 0),
  totalTargetMTD: BRANCHES.reduce((s, b) => s + b.monthlyTarget, 0),
  branchCount: BRANCHES.length,
  skuCount: SKUS.length * 60, // sample × variants
  stockoutSKUs: 312,
  overstockSKUs: 487,
  forecastAccuracy: 0.782,
  inventoryTurnover: 9.4,
  daysSalesInventory: 38.7,
  supplierOTD: 0.842,
  shopeeConversion: 0.041,
  onlineFillRate: 0.961,
  grossMargin: 0.318,
  inventoryValue: BRANCHES.reduce((s, b) => s + b.inventoryValue, 0),
  inventoryAccuracy: 0.962,
};

// ----- KPI FRAMEWORK (Part IX) -----
export const KPI_FRAMEWORK = [
  { category: "Revenue", name: "Total Daily / Monthly Revenue", definition: "Gross revenue across all channels & branches", target: "Track vs monthly target", actual: KPI_SNAPSHOT.totalRevenueMTD, format: "peso", goal: KPI_SNAPSHOT.totalTargetMTD, status: "warning" },
  { category: "Revenue", name: "Revenue by Channel", definition: "Physical / Shopee / Direct mix", target: "Track channel mix trend", actual: 0.66, format: "share", status: "success" },
  { category: "Inventory", name: "Branch Stockout Rate", definition: "% of active SKUs with zero stock", target: "<5% for A-class", actual: 0.047, format: "pct", status: "success" },
  { category: "Inventory", name: "Overstock SKU Count", definition: "SKUs with >60 days of stock", target: "<10% of active SKUs", actual: 0.118, format: "pct", status: "warning" },
  { category: "Inventory", name: "Inventory Turnover", definition: "COGS ÷ Average Inventory Value", target: "8–12× per year", actual: 9.4, format: "x", status: "success" },
  { category: "Inventory", name: "Days Sales of Inventory (DSI)", definition: "Average days to sell current inventory", target: "30–45 days", actual: 38.7, format: "days", status: "success" },
  { category: "Supply Chain", name: "Supplier On-Time Delivery", definition: "% POs delivered within agreed lead time", target: ">85%; alert <75%", actual: 0.842, format: "pct", status: "warning" },
  { category: "Supply Chain", name: "Import Lead Time Compliance", definition: "Actual PO→receipt vs planned", target: "Track variance per supplier", actual: 0.91, format: "pct", status: "success" },
  { category: "Supply Chain", name: "Container / PO Sell-Through Rate", definition: "% of container/PO volume sold within 90 days of DC receipt", target: ">70% at 90 days; alert <55%", actual: 0.74, format: "pct", status: "success" },
  { category: "Forecasting", name: "Demand Forecast Accuracy", definition: "1 − (|Actual − Forecast| / Actual)", target: ">75% weighted (A-class)", actual: 0.782, format: "pct", status: "success" },
  { category: "E-Commerce", name: "Shopee Conversion Rate", definition: "Orders ÷ Listing Views", target: "Track vs category benchmark", actual: 0.041, format: "pct", status: "info" },
  { category: "E-Commerce", name: "Online Order Fill Rate", definition: "% online orders fulfilled on-time, in-full", target: ">95%", actual: 0.961, format: "pct", status: "success" },
  { category: "Financial", name: "Gross Margin", definition: "(Revenue − COGS) ÷ Revenue", target: "Track by category", actual: 0.318, format: "pct", status: "success" },
  { category: "Financial", name: "Revenue per Branch", definition: "Monthly branch revenue", target: "Identify bottom quartile", actual: KPI_SNAPSHOT.totalRevenueMTD / BRANCHES.length, format: "peso", status: "info" },
  { category: "Branch Ops", name: "Branch Inventory Accuracy", definition: "Counted vs system inventory (cycle count)", target: ">98%; alert <95%", actual: 0.962, format: "pct", status: "warning" },
  { category: "HR", name: "Revenue per Branch Headcount", definition: "Monthly branch revenue ÷ staff", target: "Track labor productivity", actual: KPI_SNAPSHOT.totalRevenueMTD / BRANCHES.reduce((s, b) => s + b.headcount, 0), format: "peso", status: "info" },
];

// ----- ROLES -----
export const ROLES = [
  { id: "ceo", name: "Chief Executive Officer", short: "CEO", scope: "Enterprise" },
  { id: "vpops", name: "VP Operations", short: "VP Ops", scope: "Enterprise" },
  { id: "demand", name: "Demand Planning Manager", short: "Demand Planning", scope: "Inventory & Forecast" },
  { id: "merch", name: "Merchandising Manager", short: "Merchandising", scope: "Product & Supplier" },
  { id: "marketing", name: "Marketing Operations Mgr", short: "Marketing Ops", scope: "Channels" },
  { id: "regional", name: "Regional Manager", short: "Regional", scope: "Region" },
  { id: "branch", name: "Branch Head", short: "Branch Head", scope: "Single Branch" },
  { id: "cfo", name: "Chief Financial Officer", short: "CFO", scope: "Financial" },
];

// ----- DIGITAL TWIN — Context layers -----
export const TWIN_LAYERS = [
  {
    id: "L1",
    code: "L1",
    name: "Organizational Topology",
    description: "Maps management structure (HQ → Regional → Branch) so AI recommendations route to the right decision level.",
    nodes: [
      { id: "HQ", label: "1Rotary HQ", level: 0, parent: null, count: 1 },
      { id: "VP", label: "VP Operations", level: 1, parent: "HQ", count: 1 },
      { id: "DP", label: "Demand Planning", level: 1, parent: "HQ", count: 1 },
      { id: "MM", label: "Merchandising", level: 1, parent: "HQ", count: 1 },
      { id: "MO", label: "Marketing Ops", level: 1, parent: "HQ", count: 1 },
      { id: "RM-NCR", label: "RM — Metro Manila", level: 2, parent: "VP", count: 25 },
      { id: "RM-SL", label: "RM — South Luzon", level: 2, parent: "VP", count: 25 },
      { id: "RM-NL", label: "RM — North Luzon", level: 2, parent: "VP", count: 25 },
      { id: "RM-VIS", label: "RM — Visayas", level: 2, parent: "VP", count: 9 },
      { id: "RM-MIN", label: "RM — Mindanao", level: 2, parent: "VP", count: 8 },
    ],
  },
  {
    id: "L2",
    code: "L2",
    name: "Policy & Rules",
    description: "Operating policies — MOQs, supplier terms, pricing & credit guardrails — within which AI recommendations operate.",
    rules: [
      { name: "Minimum Order Quantity", detail: "Sanden compressors: 50 units / shipment; Freon R32: 100 cans", status: "active" },
      { name: "Supplier Payment Terms", detail: "Import: 60–90 day LC; Local: Net-30", status: "active" },
      { name: "Markup Policy", detail: "A-class: 18–24%; B-class: 22–30%; C-class: 28–42%", status: "active" },
      { name: "Branch Credit Limit", detail: "Tier-1 corporate accounts: ₱500K; Tier-2: ₱150K", status: "active" },
      { name: "Reorder Policy", detail: "ROP = (Lead Time × Avg Daily Demand) + Safety Stock", status: "active" },
      { name: "Promotion Cadence", detail: "Shopee — 9.9 / 10.10 / 11.11 / 12.12 anchor events", status: "active" },
    ],
  },
  {
    id: "L3",
    code: "L3",
    name: "Operational State",
    description: "Real-time synchronization of inventory, orders, POs, lead times, promotions, weather.",
    state: [
      { label: "Live Inventory Records", value: "612,840" },
      { label: "Open Sales Orders", value: "3,184" },
      { label: "Open Purchase Orders", value: "89" },
      { label: "In-Transit Shipments", value: "12" },
      { label: "Branch Sync Health", value: "94%" },
      { label: "Last Sync", value: "37 sec ago" },
    ],
  },
  {
    id: "L4",
    code: "L4",
    name: "Process & Workflow",
    description: "Digital models of core processes — sales → replenishment → procurement → product lifecycle.",
    processes: [
      { name: "Branch Replenishment", steps: ["Demand Signal", "AI Reorder Calc", "Approval", "Transfer/PO", "Receipt"], health: 0.92 },
      { name: "Import Procurement", steps: ["Forecast Roll-up", "Supplier RFQ", "PO Issue", "LC Setup", "Port Clearance", "DC Receipt"], health: 0.78 },
      { name: "Omnichannel Fulfillment", steps: ["Order", "Allocate", "Pick", "Ship", "Confirm"], health: 0.96 },
      { name: "New SKU Introduction", steps: ["Demand Brief", "Supplier Source", "Pilot Branches", "Scale", "Review"], health: 0.84 },
    ],
  },
  {
    id: "L5",
    code: "L5",
    name: "External Environment",
    description: "Live external context — weather (PAGASA), LTO vehicle registration, commodity & FX, Shopee policies, competitor signals.",
    feeds: [
      { name: "PAGASA Heat Index — NCR", value: "42 °C (Extreme)", trend: "+3°C wk/wk", status: "critical" },
      { name: "PAGASA Typhoon Outlook", value: "TD Auring forming (E. Visayas)", trend: "watch", status: "warning" },
      { name: "LTO Vehicle Registrations (PH, MTD)", value: "212,400", trend: "+6.2% YoY", status: "success" },
      { name: "Copper Spot (LME)", value: "$9,820/t", trend: "+1.8% wk/wk", status: "warning" },
      { name: "PHP/USD FX", value: "₱58.42", trend: "+0.3% wk/wk", status: "info" },
      { name: "Shopee Take Rate Adjustment", value: "6.5% effective Mar 1", trend: "+0.5pp", status: "warning" },
    ],
  },
];

// ----- SIMULATION SCENARIOS -----
export const SCENARIOS = [
  {
    id: "summer-surge",
    name: "Summer Demand Surge",
    icon: "Sun",
    short: "Pre-position inventory for projected summer aircon-parts surge",
    inputs: [
      { id: "surge", label: "Demand Surge (%)", min: 10, max: 80, default: 32, unit: "%" },
      { id: "weeks", label: "Pre-position Window (weeks)", min: 2, max: 12, default: 6, unit: "wk" },
    ],
  },
  {
    id: "el-nino",
    name: "El Niño / Extended Heat",
    icon: "Flame",
    short: "Model demand from a prolonged hot/dry season",
    inputs: [
      { id: "duration", label: "Extended Heat (months)", min: 1, max: 6, default: 4, unit: "mo" },
      { id: "tempRise", label: "Avg Temp Increase (°C)", min: 1, max: 6, default: 3, unit: "°C" },
    ],
  },
  {
    id: "new-branch",
    name: "New Branch Opening",
    icon: "Store",
    short: "Project initial stock, cannibalization & break-even for a new branch",
    inputs: [
      { id: "size", label: "Branch Size (sqm)", min: 60, max: 240, default: 140, unit: "sqm" },
      { id: "skuMix", label: "SKU Assortment (% A+B)", min: 60, max: 100, default: 82, unit: "%" },
    ],
  },
  {
    id: "shopee-flash",
    name: "Shopee Flash Sale",
    icon: "Zap",
    short: "Simulate flash sale order volume & pre-position inventory",
    inputs: [
      { id: "discount", label: "Discount (%)", min: 5, max: 50, default: 22, unit: "%" },
      { id: "skus", label: "SKUs in Promotion", min: 20, max: 600, default: 240, unit: "" },
    ],
  },
  {
    id: "supply-disruption",
    name: "Supply Chain Disruption",
    icon: "AlertTriangle",
    short: "Model impact of port/supplier disruption on stockouts & revenue",
    inputs: [
      { id: "delay", label: "Supplier Delay (days)", min: 7, max: 90, default: 28, unit: "d" },
      { id: "supplierShare", label: "Supplier Share (%)", min: 5, max: 80, default: 24, unit: "%" },
    ],
  },
  {
    id: "sku-rationalize",
    name: "SKU Rationalization",
    icon: "Filter",
    short: "Revenue/working-capital impact of phasing out low-velocity SKUs",
    inputs: [
      { id: "share", label: "SKU Tail Cut (%)", min: 5, max: 40, default: 18, unit: "%" },
    ],
  },
  {
    id: "network-opt",
    name: "Branch Network Optimization",
    icon: "Network",
    short: "Identify optimal expansion / consolidation opportunities",
    inputs: [
      { id: "openings", label: "New Branches", min: 0, max: 15, default: 5, unit: "" },
      { id: "closures", label: "Branch Closures", min: 0, max: 10, default: 2, unit: "" },
    ],
  },
];

// Run simulation deterministically based on inputs
export function runSimulation(scenarioId, inputs) {
  switch (scenarioId) {
    case "summer-surge": {
      const surge = inputs.surge / 100;
      const weeks = inputs.weeks;
      const baseUnits = 184_000;
      const additional = Math.round(baseUnits * surge);
      const addRevenue = additional * 1240;
      const additionalInv = Math.round(addRevenue * 0.62);
      return {
        outcomes: [
          { label: "Additional Demand (units)", value: additional, format: "num" },
          { label: "Incremental Revenue", value: addRevenue, format: "peso" },
          { label: "Additional Inventory Required", value: additionalInv, format: "peso" },
          { label: "Stockout Risk Avoided", value: 0.74 + Math.min(weeks * 0.02, 0.18), format: "pct" },
        ],
        series: Array.from({ length: weeks + 2 }).map((_, i) => ({
          week: `W${i + 1}`,
          baseline: Math.round(baseUnits / 4),
          forecast: Math.round((baseUnits / 4) * (1 + surge * (i >= 2 ? 1 : i / 2))),
        })),
        narrative: `Projected ${(surge * 100).toFixed(0)}% surge over ${weeks} weeks. Pre-position ${Math.round(additionalInv / 1e6)}M₱ inventory in Metro Manila + Cebu hubs. Focus: Freon R32, Inverter Compressors, Auxiliary Fans.`,
      };
    }
    case "el-nino": {
      const months = inputs.duration;
      const temp = inputs.tempRise;
      const uplift = Math.min(0.18 + temp * 0.04 + months * 0.025, 0.55);
      const revUplift = 142_000_000 * months * uplift;
      return {
        outcomes: [
          { label: "Demand Uplift", value: uplift, format: "pct" },
          { label: "Incremental Revenue (period)", value: revUplift, format: "peso" },
          { label: "Critical SKU Categories", value: "Compressors, Freon, Capacitors", format: "text" },
          { label: "Import Reorder Acceleration", value: "+18 days earlier", format: "text" },
        ],
        series: Array.from({ length: months }).map((_, i) => ({
          month: `M${i + 1}`,
          baseline: 142_000_000,
          forecast: Math.round(142_000_000 * (1 + uplift * ((i + 1) / months))),
        })),
        narrative: `${months}-month extended heat with +${temp}°C drives ${(uplift * 100).toFixed(0)}% demand uplift. Accelerate import POs by 18 days; lock-in supplier capacity now.`,
      };
    }
    case "new-branch": {
      const size = inputs.size;
      const mix = inputs.skuMix / 100;
      const initialInv = Math.round(size * 38_000 * (0.7 + mix * 0.5));
      const monthly = Math.round(initialInv * 0.32);
      const breakEven = Math.max(6, Math.round(initialInv / (monthly * 0.32)));
      return {
        outcomes: [
          { label: "Initial Inventory Investment", value: initialInv, format: "peso" },
          { label: "Projected Monthly Revenue (yr-1)", value: monthly, format: "peso" },
          { label: "Cannibalization (nearby branches)", value: 0.08 + mix * 0.04, format: "pct" },
          { label: "Break-even", value: `${breakEven} months`, format: "text" },
        ],
        series: Array.from({ length: 12 }).map((_, i) => ({
          month: `M${i + 1}`,
          revenue: Math.round(monthly * (0.4 + i * 0.07)),
          cumulative: Math.round(monthly * (0.4 + i * 0.07) * (i + 1) * 0.6),
        })),
        narrative: `A ${size}sqm branch with ${(mix * 100).toFixed(0)}% A+B SKU mix. Break-even in ${breakEven} months, with ~${Math.round((0.08 + mix * 0.04) * 100)}% cannibalization of adjacent branches.`,
      };
    }
    case "shopee-flash": {
      const disc = inputs.discount / 100;
      const skus = inputs.skus;
      const orders = Math.round(skus * 38 * (1 + disc * 2));
      const rev = Math.round(orders * 1450 * (1 - disc * 0.6));
      const stockoutRisk = Math.min(0.08 + disc * 0.5, 0.62);
      return {
        outcomes: [
          { label: "Projected Orders (24h)", value: orders, format: "num" },
          { label: "Campaign Revenue", value: rev, format: "peso" },
          { label: "Margin Impact", value: -disc * 0.6, format: "pct" },
          { label: "Stockout Risk", value: stockoutRisk, format: "pct" },
        ],
        series: Array.from({ length: 24 }).map((_, h) => ({
          hour: `${h}h`,
          orders: Math.round((orders / 24) * (h < 4 || h > 20 ? 0.4 : 1.6) * r(0.8, 1.2)),
        })),
        narrative: `At ${(disc * 100).toFixed(0)}% discount across ${skus} SKUs, projected ${orders.toLocaleString()} orders. Pre-position inventory in Metro Manila + 3PL hubs to keep fill-rate >95%.`,
      };
    }
    case "supply-disruption": {
      const delay = inputs.delay;
      const share = inputs.supplierShare / 100;
      const lostUnits = Math.round(96_000 * share * (delay / 30));
      const lostRev = lostUnits * 1380;
      return {
        outcomes: [
          { label: "Projected Stockout Units", value: lostUnits, format: "num" },
          { label: "Revenue at Risk", value: lostRev, format: "peso" },
          { label: "Branches Affected", value: ri(28, 78), format: "num" },
          { label: "Alternate Sourcing Cost Premium", value: 0.12 + share * 0.18, format: "pct" },
        ],
        series: Array.from({ length: Math.ceil(delay / 7) }).map((_, i) => ({
          week: `W${i + 1}`,
          stockoutUnits: Math.round((lostUnits / Math.ceil(delay / 7)) * (i + 1)),
        })),
        narrative: `${delay}-day disruption from a supplier holding ${(share * 100).toFixed(0)}% share creates ${lostUnits.toLocaleString()} stockout units. Trigger alternate sourcing at +${((0.12 + share * 0.18) * 100).toFixed(0)}% premium and air-freight A-class.`,
      };
    }
    case "sku-rationalize": {
      const share = inputs.share / 100;
      const cutCount = Math.round(SKUS.length * 60 * share);
      const wcFreed = Math.round(KPI_SNAPSHOT.inventoryValue * share * 0.55);
      const revLoss = Math.round(KPI_SNAPSHOT.totalRevenueMTD * share * 0.06);
      return {
        outcomes: [
          { label: "SKUs Discontinued", value: cutCount, format: "num" },
          { label: "Working Capital Freed", value: wcFreed, format: "peso" },
          { label: "Estimated Revenue Loss (monthly)", value: -revLoss, format: "peso" },
          { label: "Net Capital Efficiency Gain", value: (wcFreed - revLoss * 6) / wcFreed, format: "pct" },
        ],
        series: [
          { stage: "Current", count: SKUS.length * 60, capital: KPI_SNAPSHOT.inventoryValue },
          { stage: "Post-cut", count: SKUS.length * 60 - cutCount, capital: KPI_SNAPSHOT.inventoryValue - wcFreed },
        ],
        narrative: `Phasing out ${cutCount.toLocaleString()} low-velocity SKUs frees ${Math.round(wcFreed / 1e6)}M₱ in working capital with marginal ${Math.round(revLoss / 1e6)}M₱/mo revenue impact.`,
      };
    }
    case "network-opt":
    default: {
      const open = inputs.openings || 0;
      const close = inputs.closures || 0;
      const netRev = open * 4_200_000 - close * 2_100_000;
      const netCapEx = open * 8_400_000 - close * 1_200_000;
      return {
        outcomes: [
          { label: "Net Monthly Revenue", value: netRev, format: "peso" },
          { label: "Net CapEx Investment", value: netCapEx, format: "peso" },
          { label: "Payback Period", value: `${Math.max(8, Math.round(netCapEx / Math.max(netRev, 1)))} months`, format: "text" },
          { label: "Network Size", value: BRANCHES.length + open - close, format: "num" },
        ],
        series: [
          { stage: "Current", branches: BRANCHES.length, revenue: KPI_SNAPSHOT.totalRevenueMTD },
          { stage: "Proposed", branches: BRANCHES.length + open - close, revenue: KPI_SNAPSHOT.totalRevenueMTD + netRev },
        ],
        narrative: `Network grows by ${open - close} branches with ~${Math.round(netRev / 1e6)}M₱ net monthly revenue impact. Recommend prioritizing Mindanao expansion (low density, high vehicle registration growth).`,
      };
    }
  }
}

// ----- COPILOT canned Q&A -----
export const COPILOT_SUGGESTIONS = [
  "Which branches are most at risk of stockout this week?",
  "What is the forecast for Freon R32 next 90 days?",
  "Compare physical vs Shopee margin by category",
  "Top 10 underperforming branches and why",
  "Which suppliers need escalation?",
  "Simulate a 30% summer surge in Metro Manila",
];

export const COPILOT_RESPONSES = {
  default: "I pulled this from the Operational Digital Twin. Ask me about inventory, demand, suppliers, branches, or run a simulation.",
  stockout: "12 branches are at >70% stockout risk this week, concentrated in Visayas (Cebu, Mandaue, Lapu-Lapu) and North Luzon (Tarlac, Olongapo). Critical SKUs: Sanden SD7H15, Inverter 1.5HP, Freon R32. I've drafted 4 emergency PO transfers in the Procurement workbench.",
  forecast: "Freon R32 (9.5kg) — next 90 days forecast: 18,420 units (+24% vs prior period). Drivers: PAGASA heat advisory (NCR/CL), Shopee 4.4 promo, +6% YoY vehicle registrations. Recommend importing 14,200 units now; current pipeline covers 70% of demand.",
  margin: "Physical: 31.8% GM. Shopee: 24.6% GM (after take-rate 6.5%, ads 4.2%). Direct/WhatsApp: 34.1% GM. Recommendation: prioritize Shopee for B/C-class velocity SKUs, route A-class to direct & physical.",
  underperforming: "Bottom 10 by achievement: Calapan (62%), Sorsogon (66%), Vigan (68%), Aparri (71%), Solano (72%), Cotabato (74%), Iba (75%), Tagum (76%), Daet (77%), Iligan (78%). Common: low SKU coverage, high stockouts on A-class, weak local foot traffic. Recommend SKU rebalancing + replenishment escalation.",
  suppliers: "3 suppliers need escalation: Honeywell Refrigerants (OTD 74% — 6-mo low), Capella Industrial (14-day delay on inbound shipment), Embraco (OTD 71%, 3 critical compressor SKUs at risk). Drafted escalation emails in your queue.",
  simulate: "Simulation routed to Workbench → Summer Demand Surge (32% surge, 6-week pre-position). Result: +₱228M revenue uplift, ₱141M additional inventory needed, 92% stockout risk avoidance. Open Workbench →",
};

export function copilotAnswer(q) {
  const k = q.toLowerCase();
  if (k.includes("stockout") || k.includes("risk")) return COPILOT_RESPONSES.stockout;
  if (k.includes("forecast") || k.includes("freon") || k.includes("demand")) return COPILOT_RESPONSES.forecast;
  if (k.includes("margin") || k.includes("shopee") || k.includes("channel")) return COPILOT_RESPONSES.margin;
  if (k.includes("underperform") || k.includes("bottom") || k.includes("worst")) return COPILOT_RESPONSES.underperforming;
  if (k.includes("supplier") || k.includes("escalat")) return COPILOT_RESPONSES.suppliers;
  if (k.includes("simulat") || k.includes("scenario") || k.includes("surge")) return COPILOT_RESPONSES.simulate;
  return COPILOT_RESPONSES.default;
}
